import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import HookablePoint from './HookablePoint';
import useMapLocation from './hooks/useMapLocation';
import MapSizeContext from './MapSizeContext';

export interface IWaypointProps {
  point: any;
  selected: boolean;
  visible: boolean;
  monitor: string;
  fullFormat: boolean;
  Longitute: string;
  Latitude: string;
  wpn: string;
  WPN: string;
  isPrimaryHooked: boolean;
  isSecondaryHooked: boolean;
  hookProperties: any;
  fillingColor: string;
  labelFontSize: string;
}

interface Position {
  x?: number;
  y?: number;
}

const Container = styled.div<Position>`
  position: absolute;
  left: 0;
  top: 0;
`;
export default function WayPoint(props: IWaypointProps) {
  const {
    point,
    monitor,
    selected,
    fullFormat,
    Longitute,
    Latitude,
    wpn,
    WPN,
    hookProperties,
    fillingColor,
    labelFontSize,
  } = props;

  const [position, setPosition] = useState({
    x: 0,
    y: 0,
    latitude: ``,
    longitude: ``,
  });

  const sizes = useContext(MapSizeContext);
  const { latLangToXY, rerender } = useMapLocation(monitor, sizes);

  useEffect(() => {
    if (fullFormat) {
      const [translatedX, translatedY] = latLangToXY(Longitute, Latitude);
      setPosition({
        x: translatedX,
        y: translatedY,
        latitude: Latitude,
        longitude: Longitute,
      });
    } else if (point) {
      const latitude = `${point.latV} ${point.latH}`;
      const longitude = `${point.longV} ${point.longH}`;

      const [translatedX, translatedY] = latLangToXY(longitude, latitude);

      setPosition({
        x: translatedX,
        y: translatedY,
        latitude: latitude,
        longitude: longitude,
      });
    }
  }, [point, rerender]);
  const waypointLabel = WPN || wpn;
  return (
    <>
      <HookablePoint
        x={position.x}
        y={position.y}
        id={waypointLabel}
        latitude={position.latitude}
        longitude={position.longitude}
        hookProperties={hookProperties}
        fill={fillingColor}
      />

      <text
        x={position.x}
        y={position.y - 10}
        textAnchor="middle"
        fill={'yellow'}
        stroke-width="0.5px"
        font-size={labelFontSize || '0.5em'}
      >
        {waypointLabel?.toUpperCase()}
      </text>
    </>
  );
}
